import { takeEvery, put, call } from 'redux-saga/effects'

//import cloneDeep from 'lodash/cloneDeep'

import api from 'api'
import { showAlert } from 'redux/reducers/notification'
import {
  getAlerts,
  gettingAlertSacusses,
  gettingAlertFailed,
  deleteAlert,
  setIsFetchingAlert,
  changeStatusAlert,
  markAsReadAlerts,
  //getAlertSelector,
  //setAlerts,
} from 'redux/reducers/alerts'

function* getAlertsSagaWorker() {
  try {
    const { data } = yield call([api.alerts, 'getAlerts'])
    yield put(gettingAlertSacusses(data.body))
  } catch (error) {
    yield put(gettingAlertFailed(error?.message))
    yield put(
      showAlert({
        message: 'Getting alerts data is failed',
        severity: 'error',
        timeoutHide: 0,
      })
    )
  }
}

function* deleteAlertSagaWorker({ payload }) {
  try {
    yield put(setIsFetchingAlert(true))
    yield call([api.alerts, 'deleteAlert'], payload)
    yield put(getAlerts())
  } catch (error) {
    yield put(
      showAlert({
        message: 'Delete alert was failed',
        severity: 'error',
        timeoutHide: 0,
      })
    )
    yield put(setIsFetchingAlert(false))
  }
}

function* changeStatusAlertSagaWorker({ payload }) {
  try {
    yield put(setIsFetchingAlert(true))
    const { id, ...data } = payload
    yield call([api.alerts, 'changeStatusAlert'], id, data)
    yield put(getAlerts())
  } catch (error) {
    yield put(
      showAlert({
        message: 'Update status alert was failed',
        severity: 'error',
        timeoutHide: 0,
      })
    )
    yield put(setIsFetchingAlert(false))
  }
}

function* markAsReadAlertsSagaWorker() {
  try {
    yield put(setIsFetchingAlert(true))
    yield call([api.alerts, 'markAsReadApi'])

    yield put(getAlerts())

    //const oldAlerts = yield select(getAlertSelector)

    // const newAlerts = cloneDeep(oldAlerts).map((alert) => ({
    //   ...alert,
    //   is_read: true,
    // }))

    // yield put(setAlerts(newAlerts))
  } catch (error) {
    // todo
  }
}

function* alertsSagaWocher() {
  yield takeEvery([getAlerts.type], getAlertsSagaWorker)
  yield takeEvery(deleteAlert.type, deleteAlertSagaWorker)
  yield takeEvery(changeStatusAlert.type, changeStatusAlertSagaWorker)
  yield takeEvery(markAsReadAlerts.type, markAsReadAlertsSagaWorker)
}

export default alertsSagaWocher
